export const MoneyPaperIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1794_2453)">
        <rect
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M27.865 79H58.3966C54.3016 76.375 51.5716 71.7783 51.5716 66.5517C51.5716 58.4083 58.1983 51.7817 66.3416 51.7817H66.3883V27.6667C66.3883 25.1 64.3 23 61.7216 23H27.865C25.2983 23 23.21 25.1 23.21 27.6667V74.3217C23.21 76.9 25.2983 79 27.865 79ZM30.9916 31.89C30.9916 31.2483 31.5166 30.7233 32.1583 30.7233H57.44C58.0816 30.7233 58.6066 31.2483 58.6066 31.89V40.885C58.6066 41.5267 58.0816 42.0517 57.44 42.0517H32.1583C31.5166 42.0517 30.9916 41.5267 30.9916 40.885V31.89ZM32.1583 47.0917H57.44C58.0816 47.0917 58.6066 47.605 58.6066 48.2583C58.6066 48.9 58.0816 49.425 57.44 49.425H32.1583C31.5166 49.425 30.9916 48.9 30.9916 48.2583C30.9916 47.605 31.5166 47.0917 32.1583 47.0917ZM32.1583 54.3717H51.2566C51.8983 54.3717 52.4233 54.8967 52.4233 55.5383C52.4233 56.18 51.8983 56.705 51.2566 56.705H32.1583C31.5166 56.705 30.9916 56.18 30.9916 55.5383C30.9916 54.8967 31.5166 54.3717 32.1583 54.3717ZM32.1583 61.6517H47.99C48.6316 61.6517 49.1566 62.1767 49.1566 62.8183C49.1566 63.46 48.6316 63.985 47.99 63.985H32.1583C31.5166 63.985 30.9916 63.46 30.9916 62.8183C30.9916 62.1767 31.5166 61.6517 32.1583 61.6517ZM32.1583 68.9317H47.99C48.6316 68.9317 49.1566 69.4567 49.1566 70.0983C49.1566 70.7517 48.6316 71.265 47.99 71.265H32.1583C31.5166 71.265 30.9916 70.7517 30.9916 70.0983C30.9916 69.4567 31.5166 68.9317 32.1583 68.9317Z"
          fill="white"
        />
        <path
          d="M33.3242 33.0615H56.2749V39.715H33.3242V33.0615ZM66.3421 54.1152C59.4821 54.1152 53.9054 59.6919 53.9054 66.5519C53.9054 73.4119 59.4821 78.9885 66.3421 78.9885C73.2021 78.9885 78.7904 73.4119 78.7904 66.5519C78.7904 59.6919 73.2021 54.1152 66.3421 54.1152ZM66.3444 65.3852C67.3921 65.3864 68.3965 65.8033 69.1371 66.5444C69.8778 67.2855 70.2941 68.2901 70.2947 69.3379C70.2947 71.1077 69.1164 72.5929 67.5111 73.0945V73.5565C67.5111 73.8659 67.3881 74.1627 67.1693 74.3815C66.9506 74.6003 66.6538 74.7232 66.3444 74.7232C66.035 74.7232 65.7382 74.6003 65.5194 74.3815C65.3006 74.1627 65.1777 73.8659 65.1777 73.5565V73.0934C63.5689 72.5917 62.3917 71.1077 62.3917 69.3367C62.3917 69.0273 62.5146 68.7305 62.7334 68.5117C62.9522 68.2929 63.249 68.17 63.5584 68.17C63.8678 68.17 64.1646 68.2929 64.3833 68.5117C64.6021 68.7305 64.7251 69.0273 64.7251 69.3367C64.7409 69.7552 64.9184 70.1513 65.2201 70.4418C65.5218 70.7323 65.9244 70.8946 66.3432 70.8946C66.7621 70.8946 67.1646 70.7323 67.4663 70.4418C67.768 70.1513 67.9455 69.7552 67.9614 69.3367C67.9614 68.4454 67.2357 67.7197 66.3444 67.7197C65.2964 67.7188 64.2915 67.302 63.5504 66.561C62.8094 65.8199 62.3926 64.8151 62.3917 63.767C62.3917 61.9972 63.5701 60.512 65.1777 60.0115V59.5484C65.1777 59.2389 65.3006 58.9422 65.5194 58.7234C65.7382 58.5046 66.035 58.3817 66.3444 58.3817C66.6538 58.3817 66.9506 58.5046 67.1693 58.7234C67.3881 58.9422 67.5111 59.2389 67.5111 59.5484V60.0115C69.1176 60.5132 70.2947 61.9972 70.2947 63.7682C70.2947 64.0776 70.1718 64.3744 69.953 64.5931C69.7342 64.8119 69.4375 64.9349 69.1281 64.9349C68.8186 64.9349 68.5219 64.8119 68.3031 64.5931C68.0843 64.3744 67.9614 64.0776 67.9614 63.7682C67.9455 63.3497 67.768 62.9536 67.4663 62.6631C67.1646 62.3726 66.7621 62.2103 66.3432 62.2103C65.9244 62.2103 65.5218 62.3726 65.2201 62.6631C64.9184 62.9536 64.7409 63.3497 64.7251 63.7682C64.7251 64.6607 65.4507 65.3864 66.3444 65.3864V65.3852Z"
          fill="white"
        />
        <rect
          x="0.418153"
          y="0.418153"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1794_2453)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1794_2453"
          x="-21.744"
          y="-21.744"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1794_2453"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1794_2453"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1794_2453"
          x1="9.12934"
          y1="-9.36905e-07"
          x2="55.009"
          y2="61.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
